<form>
  <div class="mt-3">
    <!-- Group Header -->
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        @if (level > 0) {
          <div
            class="level-spacer">
            &nbsp;
          </div>
        }
        <div
          class="mr-3 level-button"
          [ngClass]="'level-' + level"
          (click)="addFilterClick()">
          <i
            class="icon icon-arrow_return"
          style="transform: rotate(-90deg)"></i>
        </div>
        @if (level === 0) {
          <div
            style="font-weight: 600"
            class="mr-3">
            {{ 'FILTERS.MATCH' | translate }}
          </div>
        }
        <div class="select is-medium mr-3">
          <select
            [(ngModel)]="_filterGroup.groupType"
            [id]="_filterGroup.uId + '_GroupType'"
            [name]="_filterGroup.uId + '_GroupType'">
            <option [ngValue]="1">{{ 'FILTERS.ALL' | translate }}</option>
            <option [ngValue]="2">{{ 'FILTERS.ANY' | translate }}</option>
          </select>
        </div>
        <div [ngStyle]="{ 'font-weight': level === 0 ? 600 : 400 }">
          {{ (level === 0 ? 'FILTERS.OF-THE-FOLLOWING' : 'FILTERS.OF-THE-FOLLOWING-ARE-TRUE') | translate }}
        </div>
      </div>
      @if (level !== 0) {
        <div>
          <button
            (click)="deleteFilterGroupClick()"
            class="button is-ghost is-large ml-1">
            <i class="icon icon-remove_outline"></i>
          </button>
        </div>
      }
    </div>

    <!-- Filters -->
    @for (filter of _filterGroup?.filters; track filter.uId; let i = $index) {
      <div
        fxLayout="row"
        fxLayoutAlign="start"
        class="mt-2">
        @if (level > 0) {
          <div class="level-spacer">&nbsp;</div>
        }
        <div
          class="mr-3"
          [ngClass]="'level-' + level">
          {{ i + 1 }}
        </div>
        <topo-filter-item
          (enableSaveFilterbuttonEvent)="enableSaveFilterbutton($event)"
          [lookupTargetSchemaFields]="lookupTargetSchemaFields"
          [schema]="schema"
          [filterGroup]="_filterGroup"
          [filter]="filter"
          [workflow]="workflow"
          [useForDatamart]="useForDatamart"
          [unitsConversionValue]="unitsConversionValue"
        style="width: 100%"></topo-filter-item>
      </div>
    }
  </div>
</form>

<!-- Child Filter Groups -->
@for (childFilterGroup of _filterGroup?.filterGroups; track childFilterGroup.uId) {
  <div fxLayout="row">
    @if (level > 0) {
      <div class="level-spacer">&nbsp;</div>
    }
    <topo-filter-group
      [level]="nextLevel"
      [parentFilterGroup]="_filterGroup"
      [lookupTargetSchemaFields]="lookupTargetSchemaFields"
      [filterGroup]="childFilterGroup"
      [schema]="schema"
      [workflow]="workflow"
      [useForDatamart]="useForDatamart"
    style="width: 100%"></topo-filter-group>
  </div>
}

<div
  fxLayout="row"
  class="mt-3">
  @if (level === 0) {
    <div
      class="mr-3 level-0 level-button"
      (click)="addFilterClick()">
      <i class="icon icon-add_plus_zoom-in"></i>
    </div>
    <div
      class="mr-3 level-1 level-button"
      (click)="addFilterGroupClick()">
      <i class="icon icon-add_plus_zoom-in"></i>
    </div>
  }

  @if (level === 1) {
    <div class="level-spacer">&nbsp;</div>
    <div
      class="mr-3 level-1 level-button"
      (click)="addFilterClick()">
      <i class="icon icon-add_plus_zoom-in"></i>
    </div>
    <div
      class="mr-3 level-2 level-button"
      (click)="addFilterGroupClick()">
      <i class="icon icon-add_plus_zoom-in"></i>
    </div>
  }

  @if (level === 2) {
    <div class="level-spacer">&nbsp;</div>
    <div
      class="mr-3 level-2 level-button"
      (click)="addFilterClick()">
      <i class="icon icon-add_plus_zoom-in"></i>
    </div>
  }
</div>
